import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { setDoc, doc, serverTimestamp } from 'firebase/firestore';

const WritingTask2Write = () => {
  const { mockId } = useParams();
  const navigate = useNavigate();
  const [essay, setEssay] = useState('');
  const [error, setError] = useState('');
  const [prompt, setPrompt] = useState('');
  const [posts, setPosts] = useState([]);
  const [timer, setTimer] = useState(10 * 60); // 10 minutes
  const [submitted, setSubmitted] = useState(false);

  const minWords = 50;

// WritingTask2.jsx (around line 42)
// ⬇️ Add this comment before useEffect
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  const loadDiscussion = async () => {
    try {
      const res = await fetch(`/data/${mockId}Writing2.json`);
      const data = await res.json();
      setPrompt(data.prompt || '');
      setPosts(data.posts || []);
    } catch (err) {
      console.error('Error loading discussion:', err);
    }
  };

  loadDiscussion();
}, [mockId]);

const handleSubmit = useCallback(async () => {
  if (submitted) return;

  const wordCount = essay.trim().split(/\s+/).length;
  if (wordCount < minWords) {
    setError(`Your response must be at least ${minWords} words. Currently: ${wordCount} words.`);
    return;
  }

  const user = auth.currentUser;
  if (!user) {
    alert('You must be logged in.');
    return;
  }

  try {
    const answerRef = doc(db, 'users', user.uid, 'mockAnswers', 'mock1_writing2');
    await setDoc(answerRef, {
      essay: essay.trim(),
      createdAt: serverTimestamp(),
      email: user.email,
      name: user.displayName,
      role: 'student',
      mockId: 'mock1',
      task: 'writing2',
    });

    console.log('✅ Essay saved!');
    setSubmitted(true);
  } catch (err) {
    console.error('❌ Error saving essay:', err);
    alert('There was an error saving your essay. Please try again.');
  }
}, [essay, minWords, submitted]);

useEffect(() => {
  if (submitted) return;
  if (timer <= 0) {
    handleSubmit();
    return;
  }

  const interval = setInterval(() => {
    setTimer((prev) => prev - 1);
  }, 1000);
  return () => clearInterval(interval);
}, [timer, submitted, handleSubmit]);


  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  };


  const handleContinue = () => {
    navigate('/lessonMock/mock1/final');
  };

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-darkblue-800 text-center">Writing Task 2 - Academic Discussion</h1>

      <div className="bg-gray-100 p-4 rounded-md mb-6">
        <p className="text-gray-700 mb-4 text-center">
          <b> Write a post responding to the professor’s question.</b>
          <p>In your response you should:</p>
          <p>• express and support your opinion</p>
          <p>• make a contribution to the discussion</p>
        </p>

        <h2 className="text-lg font-semibold mb-4">Professor</h2>
        <h2><b>Your professor is teaching a class on political science.</b></h2>
        <p className="text-gray-700 mb-6 whitespace-pre-line">{prompt || 'Loading prompt...'}</p>

        <h2 className="text-lg font-semibold mb-4">Class Discussion</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {posts.map((post, idx) => (
            <div key={idx} className="bg-white p-4 rounded shadow">
              <p className="font-semibold mb-2">{post.author}:</p>
              <p className="text-gray-700">{post.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center text-gray-500 mb-4">
        <p>Minimum {minWords} words. | Word count: {essay.trim().split(/\s+/).filter(Boolean).length}</p>
        <p><span role="img" aria-label="hourglass">⏳</span>        Time remaining: {formatTime(timer)}</p>
      </div>

      <textarea
        value={essay}
        onChange={(e) => setEssay(e.target.value)}
        placeholder="Type your response here..."
        rows={15}
        className="w-full p-4 border rounded-md mb-4"
        disabled={submitted}
      />

      {error && <p className="text-red-600 mb-4 text-center">{error}</p>}

      <div className="text-center">
        {!submitted ? (
          <button
            onClick={handleSubmit}
            className="mt-4 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-lg"
          >
            Submit Response
          </button>
        ) : (
          <button
            onClick={handleContinue}
            className="mt-4 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-lg"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
};

export default WritingTask2Write;